import { render } from "./EducationSectionEditor.vue?vue&type=template&id=26594779"
import script from "./EducationSectionEditor.vue?vue&type=script&lang=js"
export * from "./EducationSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__